import { render, staticRenderFns } from "./CrowdxUseCasesSection.vue?vue&type=template&id=98bce032&scoped=true"
import script from "./CrowdxUseCasesSection.vue?vue&type=script&lang=js"
export * from "./CrowdxUseCasesSection.vue?vue&type=script&lang=js"
import style0 from "./CrowdxUseCasesSection.vue?vue&type=style&index=0&id=98bce032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bce032",
  null
  
)

export default component.exports